import { Alert, AlertTitle, Container } from '@mui/material';
import React from 'react';

import useAuth from 'hooks/useAuth';
import useLocales from 'hooks/useLocales';

interface RoleGuardProps {
    accessibleRoles: string[];
}

const RoleGuard: React.FunctionComponent<RoleGuardProps> = ({ accessibleRoles, children }) => {
    const { profile } = useAuth();
    const { translate } = useLocales();

    if (!accessibleRoles.includes(profile?.role || '')) {
        return (
            <Container>
                <Alert severity='error'>
                    <AlertTitle>{translate('permission_denied')}</AlertTitle>
                    {translate('no_permission_to_access_page')}
                </Alert>
            </Container>
        );
    }

    return <>{children}</>;
};

export default RoleGuard;
